import { render, staticRenderFns } from "./SegmentListCreateOrEditFilterInputValue.vue?vue&type=template&id=2ab5045e&scoped=true&"
import script from "./SegmentListCreateOrEditFilterInputValue.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditFilterInputValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab5045e",
  null
  
)

export default component.exports